






































































































































import { Component, Prop, Model } from 'vue-property-decorator';
import { SwExtendedVue } from '../sw-extended-vue';
import SwIconTab from './sw-icon-tab.vue';
import SwIconTabDivider from './sw-icon-tab-divider.vue';
import { IconTabGroupItem, IconTabItem } from './types';
import { tooltip } from '../tooltip-dir';

const cssPrefix = 'sw-icon-tab-group';

/**
 * @event change `(tabId: string)`
 */
@Component({
  components: {
    SwIconTabDivider,
    SwIconTab,
  },
  directives: {
    tooltip,
  },
})
export default class SwIconTabGroup extends SwExtendedVue {

  @Prop({ type: Array, required: true })
  groupItems: IconTabGroupItem[];

  @Prop({ type: String, default: 'light' })
  theme : string;

  @Prop({ type: Boolean, default: false })
  labelsOnBottom : boolean;

  @Prop({ type: String, default: 'header' })
  mode: 'header' | 'page';

  @Model('change', { type: [String], required: true })
  value: string;

  cssPrefix: string = cssPrefix;

  private onClickTabItem(tabItem: IconTabItem) {
    this.$emit('change', tabItem.tabId);
  }
}
